module.exports = __webpack_public_path__ + "img/discount17.1e853697.png";